import React from 'react';
import DirectorateList from '../features/directorates/DirectorateList';
const Directorates = () => {
    return (
        <div>
            <DirectorateList />
        </div>
    );
};

export default Directorates;